var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headLogo',{on:{"navigation":_vm.navigation}}),_c('navigation',{staticStyle:{"margin-top":"96px"},attrs:{"headTitle":_vm.headTitle,"headImg":_vm.headImg}}),_c('el-row',{staticClass:"list"},[_c('noticesdetailsdata')],1),_c('meauDialog',{attrs:{"meauValue":_vm.navigationvalue},on:{"meauFn":_vm.menu}}),_c('bottomNavigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }